"use client";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../config/firebase";
import axios from "axios";
import { useState,useContext } from "react";

import AuthContext from "../context/AuthContext";

export default function Login() {
  // const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const {user, setUser} = useContext(AuthContext);
  const handleLogin = async () => {
    try {
      setLoading(true);
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();
      const res = await axios.post(import.meta.env.VITE_APP_API_FIREBASE, { idToken });
      setUser(res.data);
    } catch (err) {
      console.error("Login failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#fcf9f5] to-white relative overflow-hidden">
      {/* Decorative Om Symbol */}
      <div className="absolute opacity-[0.03] text-[#B82A1E] text-[400px] font-serif top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none pointer-events-none">
        ॐ
      </div>
      
      {/* Mandala-inspired decorative circles */}
      <div className="absolute -top-32 -right-32 w-64 h-64 border border-[#B82A1E]/5 rounded-full"></div>
      <div className="absolute -top-24 -right-24 w-48 h-48 border border-[#B82A1E]/5 rounded-full"></div>
      <div className="absolute -top-16 -right-16 w-32 h-32 border border-[#B82A1E]/5 rounded-full"></div>
      <div className="absolute -bottom-32 -left-32 w-64 h-64 border border-[#B82A1E]/5 rounded-full"></div>
      <div className="absolute -bottom-24 -left-24 w-48 h-48 border border-[#B82A1E]/5 rounded-full"></div>
      <div className="absolute -bottom-16 -left-16 w-32 h-32 border border-[#B82A1E]/5 rounded-full"></div>
      
      <div className="bg-white shadow-xl rounded-2xl p-10 w-full max-w-md z-10 relative border border-[#B82A1E]/10">
        {/* Login Card Header */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-20 mb-6 rounded-full flex items-center justify-center bg-gradient-to-br from-[#B82A1E]/10 to-[#B82A1E]/5">
            <span className="text-[#B82A1E] text-3xl font-serif">ॐ</span>
          </div>
          <h2 className="text-3xl font-serif text-[#5D4037] mb-2">Sign In With Google</h2>
          <div className="h-0.5 w-16 bg-gradient-to-r from-transparent via-[#B82A1E]/30 to-transparent"></div>
        </div>
        
        <p className="mb-8 text-[#5D4037]/70 text-center">
          Sign in to access the spiritual journey
        </p>
        
        {user ? (
          <div className="text-center">
            <div className="mb-6 p-4 bg-[#fcf9f5] rounded-lg border border-[#B82A1E]/10">
              <p className="text-[#5D4037] font-medium text-xl mb-1">Namaste {user.displayName}</p>
              <p className="text-[#5D4037]/70 text-sm">You have successfully signed in</p>
            </div>
            <button 
              onClick={() => window.location.href = '/'}
              className="group relative overflow-hidden bg-gradient-to-r from-[#B82A1E] to-[#8a1f16] text-white px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 w-full"
            >
              <span className="absolute top-0 left-0 w-full h-full bg-white opacity-10 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
              <span className="relative flex items-center justify-center">
                Continue to Site
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </span>
            </button>
          </div>
        ) : (
          <div>
            <button
              onClick={handleLogin}
              disabled={loading}
              className="group relative overflow-hidden bg-gradient-to-r from-[#B82A1E] to-[#8a1f16] text-white px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 w-full flex items-center justify-center"
            >
              <span className="absolute top-0 left-0 w-full h-full bg-white opacity-10 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
              <span className="relative flex items-center">
                {loading ? (
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <>
                    <svg className="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" />
                      <path fill="#FBBC05" d="M3.153 7.3455L6.4385 9.755C7.32 7.554 9.4785 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.159 2 4.828 4.1685 3.153 7.3455Z" />
                      <path fill="#EB4335" d="M12 22C14.583 22 16.93 21.0115 18.7045 19.404L15.6095 16.785C14.5717 17.5742 13.3037 18.001 12 18C9.399 18 7.19 16.3415 6.35875 14.027L3.09875 16.5395C4.75258 19.778 8.11429 22 12 22Z" />
                      <path fill="#34A853" d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.785L18.7045 19.404C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" />
                    </svg>
                    Sign in with Google
                  </>
                )}
              </span>
            </button>
            
            {/* Guest login option */}
            <div className="mt-6 text-center">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-[#B82A1E]/10"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-[#5D4037]/60">or</span>
                </div>
              </div>
              
              <button
                onClick={() => window.location.href = '/'}
                className="mt-4 text-[#5D4037] hover:text-[#B82A1E] transition-colors duration-200"
              >
                Back
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
